export default "__VITE_ASSET__e913085a__"